(function($) {
  var $document           = $(document);
  var $documentHeight     = $document.height();
  var $window             = $(window);
  var $windowWidth        = $window.width();
  var $windowHeight       = $window.height();
  var $html               = $('html');
  var $scrollTop          = $window.scrollTop();
  var $lastScrollTop      = $scrollTop;
  var $cursor             = $('.cursor');
  var $splitLines         = false;
  var $splitWrappers      = false;
  var $xs                 = window.matchMedia('(max-width: 374px)');
  var $sm                 = window.matchMedia('(max-width: 640px)');
  var $md                 = window.matchMedia('(max-width: 900px)');
  var $lg                 = window.matchMedia('(max-width: 1200px)');
  var $xl                 = window.matchMedia('(max-width: 1440px)');
  var $vh                 = document.body.clientHeight;
  var $ua                 = navigator.userAgent;
  var $imagesLoaded       = false;
  var $loaderComplete     = false;

  if($ua.indexOf('Safari') !== -1 && $ua.indexOf('Chrome') === -1) {
    $html.addClass('safari');
  }
  if($ua.indexOf('Chrome') !== -1) {
    $html.addClass('chrome');
  }
  if($ua.match(/iP(hone|od|ad)/i) ) {
    $html.addClass('browser-ios');
  }
  if($ua.indexOf('MSIE 10') !== -1) {
    $html.addClass('browser-ie ie10');
  }
  if(!!window.MSInputMethodContext && !!document.documentMode) {
    $html.addClass('browser-ie ie11');
  }
  if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test($ua)) {
    $html.addClass('browser-mobile');
  }

  $window.resize(function() {
    $documentHeight     = $document.height();
    $windowWidth = $window.width();
    $windowHeight = $window.height();
  });

  $window.scroll(function(e) {
    $scrollTop = $window.scrollTop();

    // check of document has resized
    if($documentHeight !== $document.height()) {
      // set up new parallax elements
      setupParallax();

      // set up new section scroll triggers
      setupSections();

      // refresh existing scrolltriggers
      ScrollTrigger.refresh();

      $documentHeight = $document.height();
    }

    // toggle "is-top" class
    if($scrollTop < 10) {
      $html.addClass('is-top');
    } else {
      $html.removeClass('is-top');
    }

    // set scroll direction
    if($scrollTop < $lastScrollTop) {
      $html.attr('data-direction', 'up');
    } else {
      $html.attr('data-direction', 'down');
    }

    // hide/show .btn-scroll
    if($scrollTop > ($windowHeight/2)) {
      $('.btn-scroll').addClass('hide-btn');
    } else {
      $('.btn-scroll').removeClass('hide-btn');
    }

    $lastScrollTop = $scrollTop;
  });

  // mobile vh fix
  function adjustVH() {
    if($html.hasClass('browser-ios') || ($html.hasClass('browser-mobile') && $html.hasClass('chrome'))) {
      $vh = document.body.clientHeight;
      $html.get(0).style.setProperty('--vh', $vh+'px');
    } else {
      $html.get(0).style.removeProperty('--vh');
    }
  }
  function checkVH() {
    var $diff = Math.abs($vh - $windowHeight);

    if($diff > 100) {
      adjustVH();
    }
  }

  // helper: check if partial classname exists
  $.fn.hasPartialClass = function(partial) {
    return new RegExp(partial).test(this.prop('class')); 
  };

  // open menu
  function openMenu() {
    var $menuToggleLabel = $('.menu-toggle__label');
    $menuToggleLabel.html($menuToggleLabel.data('menu-close'));
    $html.addClass('state--show-menu');
  }

  // close menu
  function closeMenu() {
    var $menuToggleLabel = $('.menu-toggle__label');
    $menuToggleLabel.html($menuToggleLabel.data('menu-open'));
    $html.removeClass('state--show-menu');
  }
  
  // toggle menu
  function toggleMenu() {
    if($html.hasClass('state--show-menu')) {
      closeMenu();
    } else {
      openMenu();
    }
  }

  // cursor movement
  function mousemoveCursor(e) {
    var $x = e.clientX;
    var $y = e.clientY;

    gsap.killTweensOf($cursor);
    gsap.to($cursor, 0.25, { x:$x, y:$y, ease:'power2' });
  }

  // cursor mouseover
  function mouseoverCursor() {
    var $el = $(this);

    if($el.hasClass('menu-toggle') || $el.hasClass('logo')) {
      $cursor.addClass('hover-lg');
    } else if($el.hasClass('btn-primary') || $el.hasClass('rct_button--primary')) {
      $cursor.addClass('hover-lg hover-hide');
    } else if($el.hasPartialClass('btn-circle')) {
      $cursor.addClass('hover-hide');
    } else {
      $cursor.addClass('hover');
    }
  }

  // cursor mouseout
  function mouseoutCursor() {
    $cursor.removeClass('hover hover-lg hover-hide active');
  }

  // cursor mousedown
  function mousedownCursor() {
    var $el = $(this);

    if($el.hasClass('btn-primary') || $el.hasClass('rct_button--primary')) {
      $cursor.addClass('active');
    }
  }

  // cursor mouseup
  function mouseupCursor() {
    var $el = $(this);

    if($el.hasClass('btn-primary') || $el.hasClass('rct_button--primary')) {
      $cursor.removeClass('active');
    }
  }

  // update inner button coordinates
  function updateButton(e) {
    var $button = $(this);
    var $x = e.pageX - $button.offset().left;
    var $y = e.pageY - $button.offset().top;

    gsap.set($button, { '--x':$x+'px', '--y':$y+'px' });
    //gsap.to($button, { '--x':$x+'px', '--y':$y+'px', duration:0.25, ease:'power2' });
  }

  // reset inner button coordinates
  function resetButton() {
    var $button = $(this);

    //gsap.killTweensOf($button);
    gsap.set($button, { clearProps:'--x,--y' });
  }

  // update magnet button position
  function updateMagnet(e) {
    var $magnet = $(this);
    var $button = $magnet.find('a, button');
    var $boundingRect = $magnet[0].getBoundingClientRect();
    var $relX = e.pageX - $boundingRect.left;
    var $relY = e.pageY - $boundingRect.top;
    var $movement = 0.3;

    gsap.to($button, 1, {
      x: ($relX - $boundingRect.width/2) * $movement,
      y: ($relY - $boundingRect.height/2 - $scrollTop) * $movement,
      ease: 'power2'
    });
  }

  // reset magnet button positioning
  function resetMagnet(e) {
    var $magnet = $(this);
    var $button = $magnet.find('a, button');

    gsap.killTweensOf($button);
    gsap.to($button, 0.3, { x:0, y:0 });
  }

  // anchor links
  function anchorLink(e) {
    var $target = $($(this).attr('href'));
    if($target.length) {
      e.preventDefault();

      gsap.to(window, 1, { scrollTo:$target.offset().top });
    }
  }

  // open accordion item
  function openAccordionItem(e) {
    e.preventDefault();

    var $accordionItem = $(this).parent();
    var $accordionGroup = $accordionItem.parent();
    var $accordionContent = $accordionItem.find('.accordion-item_copy');
    var $accordionContentHeight = $accordionItem.find('.accordion-item_copy-inner').outerHeight();

    if($accordionItem.hasClass('open')) {
      gsap.to($accordionContent, { duration:0.4, height:0, ease:'power2.out' });
      $accordionItem.removeClass('open');
    } else {
      var $openAccordionItem = $accordionGroup.find('.open');
      if($openAccordionItem) {
        var $openAccordionContent = $openAccordionItem.find('.accordion-item_copy');
        gsap.to($openAccordionContent, { duration:0.4, height:0, ease:'power2.out' });
        $openAccordionItem.removeClass('open');
      }

      gsap.to($accordionContent, { duration:0.4, height:$accordionContentHeight, ease:'power2.out' });
      $accordionItem.addClass('open');
    }
  }

  // adjust video overlay size
  function adjustVideoOverlay() {
    var $container = $('.overlay .container');
    var $containerHeight = $container.outerHeight();

    var $videoWrapper = $('.overlay .video-wrapper');
    $videoWrapper.css({ width:'100%' });
    var $videoHeight = $videoWrapper.outerHeight();

    if($videoHeight > $containerHeight) {
      var $newWidth = $containerHeight * (16/9);
      $videoWrapper.css({ width:$newWidth+'px' });
    }
  }

  // open video overlay
  function openVideoOverlay(e) {
    var $videoUrl = $(this).attr('href');
    var $video = false;

    if($videoUrl.includes('vimeo')) { // Vimeo
      var $vimeoRegExp = /https:\/\/(www\.)?vimeo.com\/(\d+)($|\/)/;
      var $vimeoMatch = $videoUrl.match($vimeoRegExp);

      if($vimeoMatch) {
        var $vimeoID = $vimeoMatch[2];
        $video = '<iframe src="https://player.vimeo.com/video/'+$vimeoID+'?autoplay=1&color=cbad71&title=0&byline=0&portrait=0" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>';
      }
    } else if($videoUrl.includes('youtube')) { // YouTube
      var $youtubeID = $videoUrl.split('v=')[1];

      var $ampersandIndex = $youtubeID.indexOf('&');
      if($ampersandIndex !== -1) {
        $youtubeID = $youtubeID.substring(0, $ampersandIndex);
      }

      $video = '<iframe width="560" height="315" src="https://www.youtube.com/embed/'+$youtubeID+'?controls=0&autoplay=1&color=cbad71" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
    } else {
      // html5 video
    }

    if($video) {
      e.preventDefault();

      $('.overlay .video-wrapper').html($video);
      $html.addClass('state--show-overlay');
    }
  }

  // close overlay
  function closeVideoOverlay() {
    $('.overlay .video-wrapper').html('');
    $html.removeClass('state--show-overlay');
  }

  // split headlines
  function splitHeadlines() {
    var $splitHeadlines = $('[data-split]');

    // unwrap
    if($splitLines) {
      // reset
      $splitWrappers.revert();
      $splitLines.revert();

      $splitLines = new SplitText($splitHeadlines, { type:'lines', linesClass:'line line++' });
      $splitWrappers = new SplitText($splitHeadlines, { type:'lines', linesClass:'line-wrapper' });

      $('[data-split][data-parallax="staggered"]').each(function() {
        setupParallaxStaggered($(this));
      });
    } else {
      $splitLines = new SplitText($splitHeadlines, { type:'lines', linesClass:'line line++' });
      $splitWrappers = new SplitText($splitHeadlines, { type:'lines', linesClass:'line-wrapper' });
      $splitHeadlines.addClass('ready');
    }
  }

  // aos elements
  function setupAos() {
    var $aosElements = $('[data-aos]');

    $aosElements.each(function() {
      var $aosEl = $(this);
      var $trigger = ($aosEl.data('aos-trigger')) ? $aosEl.data('aos-trigger') : $aosEl;
      var $start = ($aosEl.data('aos-start')) ? $aosEl.data('aos-start') : 'top 50%';

      ScrollTrigger.create({
        trigger: $trigger,
        start: $start,
        onEnter: function() {
          $aosEl.addClass('in-view');
        }
      });
    });
  }

  // staggered parallax elements
  function setupParallaxStaggered($parallaxEl) {
    var $firstLine = $parallaxEl.find('.line-wrapper:nth-child(1)');
    var $secondLine = $parallaxEl.find('.line-wrapper:nth-child(2)');
    var $thirdLine = $parallaxEl.find('.line-wrapper:nth-child(3)');
    var $remainingLines = $parallaxEl.find('.line-wrapper:gt(3)');

    if($secondLine.length) {
      var $xFrom    = ($parallaxEl.data('parallax-from'))     ? $parallaxEl.data('parallax-from')     : 25;
      var $xTo      = ($parallaxEl.data('parallax-to'))       ? $parallaxEl.data('parallax-to')       : -25;
      var $ease     = ($parallaxEl.data('parallax-ease'))     ? $parallaxEl.data('parallax-ease')     : Linear.easeNone;
      var $trigger  = ($parallaxEl.data('parallax-trigger'))  ? $parallaxEl.data('parallax-trigger')  : $parallaxEl;
      var $start    = ($parallaxEl.data('parallax-start'))    ? $parallaxEl.data('parallax-start')    : 'top 100%';
      var $end      = ($parallaxEl.data('parallax-end'))      ? $parallaxEl.data('parallax-end')      : 'bottom 0%';
      var $reverse  = ($parallaxEl.data('parallax-reverse'))  ? true                                  : false;

      if($reverse) {
        $xFrom = -$xFrom;
        $xTo = -$xTo;
      }

      if($start === 'top top') {
        $xFrom = 0;
      }

      if($firstLine.length) {
        gsap.fromTo($firstLine, {
          x: $xFrom
        }, {
          x: $xTo,
          ease: $ease,
          scrollTrigger: {
            trigger: $trigger,
            start: $start,
            end: $end,
            scrub: true
          }
        });
      }

      if($secondLine.length) {
        gsap.fromTo($secondLine, {
          x: -$xFrom
        }, {
          x: -$xTo,
          ease: $ease,
          scrollTrigger: {
            trigger: $trigger,
            start: $start,
            end: $end,
            scrub: true
          }
        });
      }

      if($thirdLine.length) {
        gsap.fromTo($thirdLine, {
          x: ($xFrom*0.5)
        }, {
          x: ($xTo*0.5),
          ease: $ease,
          scrollTrigger: {
            trigger: $trigger,
            start: $start,
            end: $end,
            scrub: true
          }
        });
      }

      if($remainingLines.length) {
        gsap.fromTo($remainingLines, {
          x: -($xFrom*0.9)
        }, {
          x: -($xTo*1.1),
          ease: $ease,
          scrollTrigger: {
            trigger: $trigger,
            start: $start,
            end: $end,
            scrub: true
          }
        });
      }
    } else {
      $parallaxEl.addClass('static');
    }
  }

  // parallax scrolling elements
  function setupParallax() {
    var $parallaxElements = $('[data-parallax]');
    $parallaxElements.each(function() {
      var $parallaxEl = $(this);
      var $type = ($parallaxEl.data('parallax') !== '') ? $parallaxEl.data('parallax') : 'vertical';

      // staggered parallax elements are special
      if($type === 'staggered') {
        setupParallaxStaggered($parallaxEl);
        return;
      }

      var $xFrom = 0;
      var $xTo = 0;
      var $yFrom = (typeof $parallaxEl.data('parallax-from') !== 'undefined') ? $parallaxEl.data('parallax-from') : 25;
      var $yTo = (typeof $parallaxEl.data('parallax-to') !== 'undefined') ? $parallaxEl.data('parallax-to') : -25;

      if($type === 'horizontal') {
        $xFrom = (typeof $parallaxEl.data('parallax-from') !== 'undefined') ? $parallaxEl.data('parallax-from') : 25;
        $xTo = (typeof $parallaxEl.data('parallax-to') !== 'undefined') ? $parallaxEl.data('parallax-to') : -25;
        $yFrom = 0;
        $yTo = 0;
      }

      var $ease = ($parallaxEl.data('parallax-ease')) ? $parallaxEl.data('parallax-ease') : Linear.easeNone;
      var $trigger = ($parallaxEl.data('parallax-trigger')) ? $parallaxEl.data('parallax-trigger') : $parallaxEl;
      var $start = ($parallaxEl.data('parallax-start')) ? $parallaxEl.data('parallax-start') : 'top 100%';
      var $end = ($parallaxEl.data('parallax-end')) ? $parallaxEl.data('parallax-end') : 'bottom 0%';

      $ease = Power2.easeOut;

      if($type === 'image') {
        $trigger = $parallaxEl.parent();
      }

      gsap.fromTo($parallaxEl, {
        xPercent: $xFrom,
        yPercent: $yFrom
      }, {
        xPercent: $xTo,
        yPercent: $yTo,
        ease: $ease,
        scrollTrigger: {
          trigger: $trigger,
          start: $start,
          end: $end,
          scrub: true
        }, 
      });
    });
  }

  // section scrolling triggers
  function setupSections() {
    var $sections = $('section');

    $sections.each(function($index) {
      var $section = $(this);
      var $lastSection = ($index === $sections.length-1);

      // trigger background color state
      gsap.from($section, {
        scrollTrigger: {
          start: 'top 1px',
          end: 'bottom top',
          trigger: $section,
          onEnter: function() {
            $section.addClass('is-active');

            if($section.hasClass('dark')) {
              $html.addClass('state--dark');
            } else {
              $html.removeClass('state--dark');
            }
          },
          onLeave: function() {
            /*if($section.hasClass('dark') && !$lastSection) {
              $html.removeClass('state--dark');
            } */
          },
          onEnterBack: function() {
            if($section.hasClass('dark')) {
              $html.addClass('state--dark');
            } else {
              $html.removeClass('state--dark');
            }
          },
          onLeaveBack: function() {
            /*if($section.hasClass('dark')) {
              $html.removeClass('state--dark');
            } */
          }
        }
      });
    });
  }

  // global footer
  function setupFooter() {
    // set footer active state when scrolled into view
    ScrollTrigger.create({
      trigger: 'footer',
      start: 'top 50%',
      toggleClass: 'is-active'
    });
  }

  // menu
  $document.on('click', '.menu-toggle', toggleMenu);

  // cursor
  $document.on('mousemove', mousemoveCursor);

  // links and buttons
  $document.on('mouseover', 'a, button, input, textarea', mouseoverCursor);
  $document.on('mouseout', 'a, button, input, textarea', mouseoutCursor);
  $document.on('mousedown', 'a, button, input, textarea', mousedownCursor);
  $document.on('mouseup', 'a, button, input, textarea', mouseupCursor);

  // primary buttons
  $document.on('mouseenter mousemove', '.btn-primary, .rct_button--primary', updateButton);
  $document.on('mouseleave', '.btn-primary, .rct_button--primary', resetButton);

  // circle buttons
  $document.on('mouseenter mouseleave', '[class^="btn-circle"]', updateButton);

  // magnetic buttons
  $document.on('mousemove', '.magnet', updateMagnet);
  $document.on('mouseleave', '.magnet', resetMagnet);

  // anchor links
  $document.on('click', 'a[href^="#"]', anchorLink);

  // videos
  $document.on('click', '.btn-play', openVideoOverlay);
  $document.on('click', '.btn-close', closeVideoOverlay);
  adjustVideoOverlay();
  $window.resize(adjustVideoOverlay);

  // accordions
  $document.on('click', '.accordion-item_heading', openAccordionItem);

  // float labels
  $('.form-row').each(function() {
    var $container = $(this);
    var $field = $container.find('input, textarea');

    if($field.val() !== '') {
      $container.addClass('focus');
    }

    $field.focus(function() {
      $container.addClass('focus');
    }).blur(function() {
      if($field.val() === '') {
        $container.removeClass('focus');
      }
    });
  });

  // split headlines
  $window.resize(function() {
    setTimeout(splitHeadlines, 250);
  });

  // images loaded
  $loadedImages = 0;
  $document.imagesLoaded().always(function(instance) {
    setTimeout(function() {
      $imagesLoaded = true;
      //if($loaderComplete) {
        // split headlines
        splitHeadlines();

        // set up aos elements
        setTimeout(setupAos, 500);

        // set up parallax elements
        setupParallax();

        // set up section scroll triggers
        setupSections();

        // set up footer scroll trigger
        setupFooter();

        $html.removeClass('state--loading');
      //}
    }, 1000);
  }).progress(function(instance) {
    $loadedImages++;
    var $percentage = Math.round(100*($loadedImages/instance.images.length))+'%';
    $('.state--loading .loader .loader-fg').css({ height:$percentage });
    $('.state--loading .loader .progress').html($percentage);
  });

  // loader
  /*var $lottie = document.querySelector('.loader .lottie-player');
  if($lottie) {
    $lottie.play();
    $lottie.addEventListener('complete', function() {
      setTimeout(function() {
        $loaderComplete = true;
        if($imagesLoaded) {
          // split headlines
          splitHeadlines();

          // set up aos elements
          setTimeout(setupAos, 500);

          // set up parallax elements
          setupParallax();

          // set up section scroll triggers
          setupSections();

          // set up footer scroll trigger
          setupFooter();

          $html.removeClass('state--loading');
        }
      }, 1000);
    });
  }*/
  
  // view height
  adjustVH(); //chrome vh fix
  $window.resize(checkVH);

})(jQuery);